// extracted by css-extract-rspack-plugin
module.exports =  {"root":"PresenceIndicator__root___iAFyP","present":"PresenceIndicator__present___MW6Qp"};